const services = [
  {
    icon: "ri-article-line",
    title: "内容策划与制作",
    desc: "围绕影视、音乐与生活方式，提供选题策划、专题制作与深度内容采写，帮助品牌与用户建立真实连接。",
    points: ["选题策划与栏目共建", "专题制作与深度采写", "多平台内容分发"],
    image:
      "https://readdy.ai/api/search-image?query=bright%20editorial%20desk%20scene%20with%20laptops%2C%20notebooks%20and%20colorful%20sticky%20notes%2C%20warm%20orange%20accents%20on%20cream%20background%2C%20minimal%20creative%20workspace%2C%20soft%20natural%20light%2C%20clean%20composition&width=900&height=700&seq=xmt-brand-svc-1&orientation=landscape",
  },
  {
    icon: "ri-megaphone-line",
    title: "品牌传播与整合营销",
    desc: "从内容策略到传播节奏，为品牌设计完整的传播组合，让信息不只是被看到，而是被记住。",
    points: ["传播策略与节奏规划", "内容创意与视觉表达", "效果复盘与优化建议"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20brand%20campaign%20visual%2C%20layered%20orange%20and%20mint%20graphic%20shapes%2C%20soft%20textures%20on%20cream%20background%2C%20modern%20minimal%20poster%20aesthetic%2C%20clean%20editorial%20design&width=900&height=700&seq=xmt-brand-svc-2&orientation=landscape",
  },
  {
    icon: "ri-team-line",
    title: "共创与联合出品",
    desc: "面向创作者、媒体与机构开放合作窗口，一起发起专栏、活动与联合出品项目。",
    points: ["创作者专栏共建", "线下活动联合策划", "IP 与内容联合出品"],
    image:
      "https://readdy.ai/api/search-image?query=creative%20team%20collaboration%20concept%2C%20people%20brainstorming%20around%20warm%20lit%20table%2C%20orange%20and%20cream%20tones%2C%20bright%20modern%20studio%2C%20editorial%20lifestyle%20photography&width=900&height=700&seq=xmt-brand-svc-3&orientation=landscape",
  },
];

export default function ServiceList() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16">
      <div className="max-w-2xl">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          我们提供什么
        </h2>
        <p className="mt-2 text-sm md:text-base text-foreground-600">
          三块核心业务，覆盖从内容生产到品牌传播的完整链路。
        </p>
      </div>

      <div className="mt-8 md:mt-12 flex flex-col gap-10 md:gap-16">
        {services.map((svc, idx) => (
          <div
            key={svc.title}
            className={`grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-center ${
              idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
            }`}
          >
            <div className="w-full h-56 md:h-80 rounded-lg overflow-hidden bg-background-200">
              <img
                src={svc.image}
                alt={`${svc.title} - 小蜜桃品牌服务`}
                title={`${svc.title} - 小蜜桃品牌服务`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <span className="w-11 h-11 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center">
                <i className={`${svc.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-xl md:text-2xl text-foreground-950">
                {svc.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                {svc.desc}
              </p>
              <ul className="mt-5 flex flex-col gap-2.5">
                {svc.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-accent-600"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}